import React from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { Button } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

const A4_WIDTH_MM = 210;
const A4_HEIGHT_MM = 297;
const MARGIN = 5;
const CONTENT_WIDTH_MM = A4_WIDTH_MM - MARGIN * 2;

const pxToMm = (px) => px * 2.164583;

// ⭐ THE REAL FIX FOR CHARTS / CANVAS
const fixChartCanvases = (originalRoot, clonedRoot) => {
  const originalCanvases = originalRoot.querySelectorAll("canvas");
  const clonedCanvases = clonedRoot.querySelectorAll("canvas");

  clonedCanvases.forEach((clonedCanvas, index) => {
    const originalCanvas = originalCanvases[index];
    if (!originalCanvas) return;

    const ctx = clonedCanvas.getContext("2d");
    ctx.drawImage(originalCanvas, 0, 0);

    const img = document.createElement("img");
    img.src = clonedCanvas.toDataURL("image/png", 1.0);
    img.style.width = originalCanvas.offsetWidth + "px";
    img.style.height = originalCanvas.offsetHeight + "px";
    img.style.display = "block";

    clonedCanvas.parentNode.replaceChild(img, clonedCanvas);
  });
};

const buildPages = (root) => {
  const blocks = Array.from(root.querySelectorAll(".pdf-include"));
  const pages = [];
  let currentPage = [];

  blocks.forEach((block) => {
    if (block.classList.contains("pdf-break") && currentPage.length) {
      pages.push(currentPage);
      currentPage = [];
    }
    currentPage.push(block);
  });

  if (currentPage.length) pages.push(currentPage);
  return pages;
};

const PdfExport = ({ contentRef, filename = "export" }) => {
  const exportPDF = async () => {
    const pages = buildPages(contentRef.current);
    const pdf = new jsPDF("p", "mm", "a4");

    for (let i = 0; i < pages.length; i++) {
      const pageWrapper = document.createElement("div");
      pageWrapper.style.background = "#fff";
      pageWrapper.style.padding = "0";
      pageWrapper.style.margin = "0";

      pages[i].forEach((block) => {
        const clone = block.cloneNode(true);
        clone.style.margin = "0";
        clone.style.padding = "0";
        pageWrapper.appendChild(clone);
      });

      document.body.appendChild(pageWrapper);

      // 🔥 Fix all canvas BEFORE html2canvas
      fixChartCanvases(contentRef.current, pageWrapper);

      await new Promise((r) => setTimeout(r, 300));

      const canvas = await html2canvas(pageWrapper, {
        scale: 2,
        useCORS: true,
        backgroundColor: "#ffffff",
      });

      const imgData = canvas.toDataURL("image/png");
      const imgHeightMm = pxToMm(canvas.height);
      const ratio = CONTENT_WIDTH_MM / pxToMm(canvas.width);
      const finalHeight = imgHeightMm * ratio;

      if (i > 0) pdf.addPage();
      pdf.addImage(
        imgData,
        "PNG",
        MARGIN,
        MARGIN,
        CONTENT_WIDTH_MM,
        finalHeight
      );

      document.body.removeChild(pageWrapper);
    }

    pdf.save(`${filename}.pdf`);
  };

  return (
    <Button
      variant="contained"
      color="success"
      startIcon={<FileDownloadIcon />}
      onClick={exportPDF}
    >
      Export PDF
    </Button>
  );
};

export default PdfExport;